(() => {
  const switcher = document.querySelector('.language-switcher__list');
	if (!switcher) {
		return;
	}

	switcher.addEventListener('change', () => {
		window.location = encodeURI(switcher.value);
	});
})();
